de:
  registrant: Melder
  backoffice: Backoffice
fr:
  backoffice: Backoffice
  registrant: Déclarant
it:
  backoffice: Backoffice
  registrant: Notificante
